import { Hidden } from '@mui/material'
import { GetStaticProps, NextPage } from 'next'
import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { ContentPagination } from 'src/components/ContentPagination/ContentPagination'
import { ExpertsCarousel } from 'src/components/ExpertsCarousel/ExpertsCarousel'
import { Footer } from 'src/components/Footer/Footer'
import MainContainer from 'src/components/global/MainContainer/MainContainer'
import { PremiumModal } from 'src/components/global/PremiumModal'
import { SearchField } from 'src/components/global/SearchField'
import { Sidebar } from 'src/components/global/Sidebar'
import { ThemeOnly } from 'src/components/global/ThemeOnly'
import { ReCaptcha } from 'src/components/ReCaptcha/ReCaptcha'
import { SHOW_SOLUTION_GUIDE_CARD, THEME } from 'src/config/config'
import { IEnum_Content_Contenttype } from 'src/graphql/generated/hooks'
import { useDecodedKeyword } from 'src/hooks/useGetDecodeKeyword'
// import { useAuthenticated } from 'src/hooks/useAuthenticated'
import { Meta } from 'src/layout/Meta'
import { Main } from 'src/templates/Main'
import { FilterOption } from 'src/types'
import {
  //getAudiencesFilter,
  getAuthorsFilter,
  getDateFilter,
  getDocumentTypesFilter,
  //getSubjectsFilter,
  getVendorTopicsFilter,
} from 'src/utils/ContentFilters/contentFilters'

type Props = {
  filters: FilterOption[]
}

const ResourcesForSolutionProvidersPage: NextPage<Props> = ({ filters }: Props) => {
  const router = useRouter()
  const [showModal, setShowModal] = useState(false)
  // const { session } = useAuthenticated()
  // const filtersDisabled = useMemo(() => !session?.user?.isPremium, [session])
  const title = SHOW_SOLUTION_GUIDE_CARD == 'true' ? 'Vendor Central' : 'Resources for Solution Providers (Beta)'
  const description = 'Helpful resources on gotomarket, marketing, fund raising, templates, events, security.'

  const searchKeyword = useDecodedKeyword(router.query.keyword)

  const meta = <Meta title={title} url={`/resources-for-solution-providers`} description={description} />
  return (
    <Main meta={meta}>
      <PremiumModal origin="/legaltech-resources-for-lawyers/" isOpen={showModal} onClose={() => setShowModal(false)} />
      <MainContainer id="mainContainer">
        <div className="flex flex-col bg-clouds">
          {/* <Breadcrumb
            className="justify-start"
            subject="INDUSTRY ANALYSIS"
            subjectRoute={`/`}
            subtitle="Resources for Solution providers"
          /> */}
          <div className="px-5 md:pl-0 !max-w-[1100px] w-full mx-auto flex flex-row items-center pt-2">
            <div className="flex-row flex mt-[1rem] mb-[3rem] w-full md:w-2/3">
              <div className="flex flex-col justify-center">
                <h1 className="pt-[0.5rem] pb-[0.625rem] text-[1.875rem] font-bold font-secondary text-darkgray">
                  {title}
                </h1>
                <h2 style={{ fontWeight: 450 }} className=" text-[0.9375rem] font-primary font-regular text-darkgray">
                  {description}
                </h2>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="flex flex-col justify-center w-full md:pl-0 md:pr-0 px-[20px]">
          <div className="flex flex-row justify-center w-full md:pl-0 md:pr-0 md:px-[20px]">
            <div className="!max-w-[1100px] flex flex-row justify-between w-full mb-32">
              <Hidden mdDown>
                <div className="w-1/4 pr-10 flex flex-col">
                  <SearchField className="my-8" />
                  <Sidebar
                    filterOptions={filters}
                    // filtersDisabled={filtersDisabled}
                    defaultSelectFilterIdx={1}
                    onClickWhenDisabled={() => setShowModal(true)}
                  />
                </div>
              </Hidden>
              <ReCaptcha>
                <ContentPagination
                  filterProps={filters}
                  // filtersDisabled={filtersDisabled}
                  onClickWhenDisabled={() => setShowModal(true)}
                  contentType={IEnum_Content_Contenttype.VendorContent}
                  searchKeyword={searchKeyword}
                />
              </ReCaptcha>
            </div>
          </div>
          <ExpertsCarousel />
        </div>
        <ThemeOnly theme="legaltech">
          <Footer />
        </ThemeOnly>
      </MainContainer>
    </Main>
  )
}

export default ResourcesForSolutionProvidersPage

export const getStaticProps: GetStaticProps<Props> = async ({}) => {
  if (THEME === 'ilta')
    return {
      revalidate: 60,
      notFound: true,
    }
  try {
    const vendorTopicsFilter: any = await getVendorTopicsFilter()
    //vendorTopicsFilter.title = 'subject'

    const documentTypesFilter: any = await getDocumentTypesFilter()
    const documentFilter = documentTypesFilter?.data?.filter(
      (item: any) => item.id === 'Review' || item.id === 'Template',
    )
    documentTypesFilter.data = documentFilter

    const filters: FilterOption[] = await Promise.all([
      // getAudiencesFilter(),
      vendorTopicsFilter, //getVendorTopicsFilter(),
      // getSubjectsFilter({ includeSubjectMatters: false, includeThemes: true }),
      documentTypesFilter, //getDocumentTypesFilter(),
      getAuthorsFilter({ includeAuthors: true, includeExperts: true }),
      getDateFilter(),
    ])
    return {
      props: {
        filters,
      },
      revalidate: 60,
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error occurred in getStaticProps of Resources for Solution Providers:', error)
    // Graceful fallback in case of an upstream error
    return {
      notFound: true,
      revalidate: 5, // Reattempt fetching during the next static regeneration
    }
  }
}
